// TableComponent.js
import React, { useState } from "react";
import Papa from "papaparse"; // Library to handle CSV export

const TableComponent = ({ Data, columns, showSearch }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState(""); // Search input state
    const rowsPerPage = 10; // Number of rows per page

    // Filtered data based on search term
    const filteredData = Data.filter((row) =>
        columns.some((col) =>
            row[col]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    // Calculate total pages after filtering
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    // Get current page data
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = filteredData.slice(indexOfFirstRow, indexOfLastRow);

    // Function to format table headers (Remove underscores & capitalize words)
    const formatHeader = (header) => {
        return header
            .replace(/_/g, " ") // Replace underscores with spaces
            .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
    };

    // Function to export table data to CSV
    const exportToCSV = () => {
        const csvData = [
            columns, // Header row
            ...filteredData.map((row) => columns.map((col) => row[col])) // Data rows
        ];
        const csv = Papa.unparse(csvData);
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "table_data.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div>
            {/* Search & Export Controls */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px", marginTop: "10px" }}>
                <button 
                    onClick={exportToCSV} 
                    style={{
                        padding: "6px 12px",
                        border: "none",
                        backgroundColor: "#28a745",
                        color: "white",
                        borderRadius: "5px",
                        cursor: "pointer"
                    }}
                >
                    Export to CSV
                </button>

                {showSearch && (
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            padding: "5px",
                            width: "300px",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                        }}
                    />
                )}
            </div>

            {/* Scrollable Table */}
            <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                <table className="table-content borderd-table" style={{ minWidth: "1000px" }}>
                    <thead>
                        <tr>
                            {columns.map((col, index) => (
                                <th key={index}>{formatHeader(col)}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {currentRows.length > 0 ? (
                            currentRows.map((item, index) => (
                                <tr key={index}>
                                    {columns.map((col, colIndex) => (
                                        <td key={colIndex}>{item[col]}</td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={columns.length} style={{ textAlign: "center", padding: "10px" }}>
                                    No matching results found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination Controls */}
            <div style={{ marginTop: "10px", display: "flex", justifyContent: "center" }}>
                <button 
                    onClick={() => setCurrentPage(currentPage - 1)} 
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                <span style={{ margin: "0 10px" }}>Page {currentPage} of {totalPages || 1}</span>
                <button 
                    onClick={() => setCurrentPage(currentPage + 1)} 
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default TableComponent;